<template>
  <div v-if="componentData && user">
    <ProfileRootComponent
      :propUser="user"
      :parent-component-data="getComponentData"
    />
  </div>
</template>

<script>
import common from '../../mixins/mixin'
import AuthenticatedPage from '../../components/AuthenticatedPage'
import ProfileRootComponent from '../../components/ProfileRootComponent'
import utils from '~/mixins/utils'

export default {
  components: { ProfileRootComponent },
  extends: AuthenticatedPage,
  mixins: [utils],
  data () {
    return {
      user: null,
      componentData: null,
      userId: null
    }
  },
  computed: {
    getComponentData () {
      return this.componentData
    }
  },
  async asyncData ({ params, store }) {
    let item = {}
    const decryptedId = Buffer.from(params.id, 'base64').toString('ascii').replace(/%2F/g, '\\/')
    if (!store.state.api.buckets.users[decryptedId] && decryptedId && decryptedId !== 'undefined') {
      item = await store.dispatch('api/ssrUserSelect', decryptedId)
    } else {
      item = store.state.api.buckets.users[decryptedId]
    }
    return { ssrEntity: item }
  },
  head () {
    if (!this.ssrEntity) {
      this.ssrEntity = this.user
    }
    return {
      title: this.ssrEntity.name,
      meta: [
        { hid: 'og:title', name: 'og:title', content: this.ssrEntity.name },
        { hid: 'description', name: 'description', content: this.ssrEntity.description || 'GOTit Social Ecommerce' },
        { hid: 'application-name', name: 'application-name', content: 'GOTit' },
        {
          hid: 'image',
          name: 'image',
          content: this.ssrEntity.image || process.env.gotitLogo
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content: this.ssrEntity.image || process.env.gotitLogo
        },
        { hid: 'url', name: 'url', content: 'https://gotitstores.com' },
        { hid: 'og:url', name: 'og:url', content: 'https://gotitstores.com' }
      ]
    }
  },
  methods: {
    async onUserReady () {
      this.userId = this.decrypt(this.$route.params.id)
      if (!this.$store.state.api.buckets.users[this.userId]) {
        const res = await this.$store.dispatch('api/usersSelect', {
          filter: 'GET',
          filterParam: this.userId
        })
        this.entity = res[0]
      } else {
        this.entity = this.$store.state.api.buckets.users[this.userId]
      }
      this.$root.$emit('popup_menu_type', 'user')
      this.componentData = await common.methods.getScreenComponentData(this.$store, 'users')
      this.componentData.type = 'ProfileRootComponent'
      this.componentData.components[2] = {
        components: [{
          components: [{ type: 'GridItemComponent' }],
          componentId: 'wantit_grid',
          entityId: this.userId,
          stream: {
            filter: 'USER_WANTIT',
            endpoint: '/items/select',
            skip: 0,
            limit: 20,
            filterParam: this.userId,
            includeProperties: true
          },
          spreading: 'REPEAT',
          type: 'GridComponent'
        }, {
          components: [{ type: 'GridItemComponent' }],
          componentId: 'purchased_grid',
          entityId: this.userId,
          stream: {
            filter: 'USER',
            endpoint: '/items/select',
            skip: 0,
            limit: 20,
            filterParam: this.userId,
            includeProperties: true
          },
          spreading: 'REPEAT',
          type: 'GridComponent'
        }],
        componentId: 'center_component',
        type: 'ProfileMainComponent'
      }
      this.user = this.$store.state.api.buckets.users[this.userId]
      if (this.user.store) {
        this.$router.push({
          path: '/stores/' + this.encrypt(this.user.id)
        })
      } else {
        this.$store.dispatch('api/trackEvent', {
          eventName: 'profile_view',
          params: {
            path: this.$route.path,
            profileId: this.user.id
          }
        }).then().catch()
      }
    }
  }
}
</script>
